import * as types from './types';

import { postRequest } from '../../services/requestService';
import {
  showErrorToast,
  showSuccessToast,
} from '../../services/notificationsService';

/**
 * Fetch pre deals per buyer
 */
export const getPreDeals = (params) => async (dispatch) => {
  const payload = {
    isFetchingPreDeals: false,
    preDeals: [],
  };
  dispatch({
    type: types.SET_IS_FETCHING_PRE_DEALS,
    payload: { isFetchingPreDeals: true },
  });

  try {
    const response = await postRequest(
      '/pre-deal/get-matching-pre-deals',
      params,
    );
    const { items } = response.data;
    payload.preDeals = items;
  } catch (e) {
    showErrorToast(`Fetching offers failed: ${e.message}`);
  }

  dispatch({
    type: types.SET_PRE_DEALS,
    payload,
  });
};

export const updateOffer = (params, callback) => async (dispatch, getState) => {
  const payload = {
    isFetchingPreDeals: false,
    preDeals: [],
  };
  const { appliedFilters } = getState().PreDealsReducer;

  try {
    dispatch({
      type: types.SET_IS_FETCHING_PRE_DEALS,
      payload: { isFetchingPreDeals: true },
    });
    const response = await postRequest('/pre-deal/update', {
      ...params,
      appliedFilters,
    });
    const { reason } = response.data;
    if (reason) {
      showErrorToast('Submitting an offer failed!');
    }
    payload.selectedPreDeal = response?.data?.updatedPreDeal;
    payload.preDeals = response?.data?.items;
    showSuccessToast(
      params.action === 'rejected_by_buyer'
        ? 'Deal successfully rejected'
        : 'Success! We updated your offer.',
    );
    if (callback) {
      callback();
    }
  } catch (error) {
    showErrorToast('Submitting an offer failed!');
  }

  dispatch({
    type: types.SET_PRE_DEALS,
    payload,
  });
};

export const setSelectedPreDeal = (preDeal) => (dispatch) => {
  dispatch({
    type: types.SET_PRE_DEAL,
    payload: {
      selectedPreDeal: preDeal || undefined,
    },
  });
};

export const exportPreDeals = (fileName, params) => async (dispatch) => {
  dispatch({
    type: types.SET_IS_DOWNLOAD_PRE_DEALS,
    payload: { isPreDealDownloading: true },
  });

  try {
    const response = await postRequest('/pre-deal/export', params);
    const { reason } = response.data;

    if (reason) {
      showErrorToast(reason);
    } else {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');

      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
    }
  } catch (e) {
    showErrorToast(`Downloading offers failed: ${e.message}`);
  }

  dispatch({
    type: types.SET_IS_DOWNLOAD_PRE_DEALS,
    payload: { isPreDealDownloading: false },
  });
};
